export default __webpack_public_path__ + "static/media/GiftBlack.94d0ece6.svg";